import { createReduxServiceModule } from '@onhandtech/onhand-fe-shared/lib/redux'
import type { RequestArgs } from '@onhandtech/onhand-fe-shared/lib/request'
import { createRequestError, formatEndpoint } from '@onhandtech/onhand-fe-shared/lib/request'
import type { AxiosError } from 'axios'
import { getConfig } from 'config/configuration'

import { createOrganisationFailureSaga } from './sagas/create-organisation-failure.saga'
import { createOrganisationSuccessSaga } from './sagas/create-organisation-success.saga'
import { handleSuccess } from './handle-success'
import {
  type CreateOrganisationNormalisedResponse,
  type CreateOrganisationRequestPayload,
  type CreateOrganisationResponse,
  moduleName,
} from './organisations.module.types'

const { endpoints } = getConfig()

const args: RequestArgs<
  CreateOrganisationResponse,
  CreateOrganisationNormalisedResponse,
  CreateOrganisationRequestPayload
> = {
  url: formatEndpoint(endpoints.api.v4.organisations),
  method: 'POST',
  handleFailure: (e: AxiosError) => createRequestError(e, moduleName),
  handleSuccess,
}

const createOrganisationModule = () =>
  createReduxServiceModule({
    moduleName,
    args,
    sagas: {
      onRequestSuccessSaga: createOrganisationSuccessSaga,
      onRequestFailureSaga: createOrganisationFailureSaga,
    },
  })

export default createOrganisationModule
